<template>
	<div class="home">
		<TopMenu></TopMenu>
		<div class="leftBar">
			<div class="navList">
				<div class="navListBox">
					<div class="navItem" :class="leftSelIndex == index ? 'naviCurItem' : ''"
						v-for="(item,index) in naviData" :key="index" @click="naviToLeftBar(item,index)">
						{{item.title}}
					</div>
				</div>
			</div>
		</div>
		<div class="videoBox">
			<div class="contentStyle" v-if="tid == 0">
				<div class="styleHeader">
					<div class="headerBox">
						<span class="headerTitle">焦点热播</span>
					</div>
					<div class="more" @click="naviToMore('焦点热播',0)">更多<span class="moreIcon iconfont">&#xe658;</span>
					</div>
				</div>
				<div class="videoListBox">
					<div class="itemBox" v-for="(item,index) in listData" :key="index" v-if="index < columnsNum">
						<div class="imgBox" @click="naviToDetails(item.VId)">
							<img :src="item.CoverURL" alt="">
							<div class="timeNumBox">
								{{item.Duration}}
								<div class="numBox">
									{{item.Clicks}}次播放
								</div>
							</div>
						</div>
						<div class="infoBox">
							<div class="videoTitle" @click="naviToDetails(item.VId)">
								{{item.Title}}
							</div>
							<div class="videoSubTitle">
								{{item.Intro}}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="contentStyle" v-for="(groups,index) in indexData" :key="index">
				<div class="styleHeader">
					<div class="headerBox">
						<!-- <span class="headerTitle">电视剧</span> -->
						<div class="secordBox">
							<div class="secordItem"
								:class="secSelIndexs[index] == gIndex ? 'secordItemActive' : 'secordItemNormal'"
								@click="changeIndex(index,gIndex)" v-for="(gItem,gIndex) in groups.list" :key="gIndex">
								{{gItem.title}}
							</div>
						</div>
					</div>
					<div class="more"
						@click="naviToMore(groups.list[secSelIndexs[index]].title,groups.list[secSelIndexs[index]].TId)">
						更多<span class="moreIcon iconfont">&#xe658;</span></div>
				</div>
				<div class="videoListTBox" v-if="(index == 0 && tid == 0) || groups.list.length > 1">
					<div class="itemTBox" v-for="(lGItem, bIndex) in groups.list[secSelIndexs[index]].list"
						:key="bIndex" v-if="bIndex == 0" style="margin-bottom: 18px;">
						<div class="imgTBox" @mouseenter="hotBigMouseEnter($event,bIndex,lGItem)">
							<img :src="lGItem.CoverURL" alt="">
							<div class="timeBox">
								{{lGItem.Duration}}
							</div>
						</div>
						<div class="infoTBox">
							<div class="videoTitle" @click="naviToDetails(lGItem.VId)">
								{{lGItem.Title}}
							</div>
							<div class="videoSubTitle">
								{{lGItem.Intro}}
							</div>
							<div class="videoDescTitle">
								{{lGItem.UpdateDate}}
								<div class="playNum">
									{{lGItem.Clicks}}次播放
								</div>
							</div>
						</div>
					</div>
					<div class="videoLengBox">
						<div class="videoListBox">
							<div class="itemBox" v-for="(lGItem, bIndex) in groups.list[secSelIndexs[index]].list"
								:key="bIndex" v-if="bIndex > 0 && bIndex < columnsNum - 1">
								<div class="imgBox" @mouseenter="hotMouseEnter($event,bIndex + 2,lGItem)">
									<img :src="lGItem.CoverURL" alt="">
									<div class="timeNumBox">
										{{lGItem.Duration}}
										<div class="numBox">
											{{lGItem.Clicks}}次播放
										</div>
									</div>
								</div>
								<div class="infoBox">
									<div class="videoTitle" @click="naviToDetails(lGItem.VId)">
										{{lGItem.Title}}
									</div>
									<div class="videoSubTitle">
										{{lGItem.Intro}}
									</div>
								</div>
							</div>
						</div>
						<div class="videoListBox">
							<div class="itemBox" v-for="(lGItem, bIndex) in groups.list[secSelIndexs[index]].list"
								:key="bIndex" v-if="bIndex > columnsNum - 2 && bIndex < 2 * columnsNum - 3">
								<div class="imgBox" @mouseenter="hotMouseEnter($event,bIndex + 2,lGItem)">
									<img :src="lGItem.CoverURL" alt="">
									<div class="timeNumBox">
										{{lGItem.Duration}}
										<div class="numBox">
											{{lGItem.Clicks}}次播放
										</div>
									</div>
								</div>
								<div class="infoBox">
									<div class="videoTitle" @click="naviToDetails(lGItem.VId)">
										{{lGItem.Title}}
									</div>
									<div class="videoSubTitle">
										{{lGItem.Intro}}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="videoListSBox" v-else>
					<div class="itemSBox" v-for="(sItem,sIndex) in groups.list[secSelIndexs[index]].list" :key="sIndex"
						v-if="sIndex < columnsNum">
						<div class="imgSBox" @mouseenter="hotMouseEnter($event,sIndex,sItem)">
							<img :src="sItem.CoverUrlPortrait" alt="">
							<div class="timeNumBox">
								{{sItem.Duration}}
								<div class="numBox">
									{{sItem.Clicks}}次播放
								</div>
							</div>
						</div>
						<div class="infoSBox">
							<div class="videoTitle" @click="naviToDetails(sItem.VId)">
								{{sItem.Title}}
							</div>
							<div class="videoSubTitle">
								{{sItem.Intro}}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<BottomMenu></BottomMenu>
		<div class="loading" v-if="isLoading">
			<img src="https://img.alicdn.com/tfs/TB1qa_fdQL0gK0jSZFtXXXQCXXa-88-88.gif" alt="">
		</div>
		<PopMenu :popX="popX" :popY="popY" :isBig="isBig" :isPop="isPop" @changeIsPop="changeIsPop"
			@naviToDetails="naviToDetails" :curReCommand="curReCommand">
		</PopMenu>
	</div>
</template>

<script>
	import TopMenu from '../components/topMenu'
	import BottomMenu from '../components/bottomMenu'
	import PopMenu from '../components/popMenu'
	export default {
		name: 'Home',
		components: {
			TopMenu,
			BottomMenu,
			PopMenu
		},
		data() {
			return {
				tid: 0,
				popX: 0,
				popY: 0,
				isPop: false,
				isBig: false,
				isLoading: false,
				screenWidth: 0,
				columnsNum: 0,
				leftSelIndex: 0,
				secSelIndexs: [],
				listData: [],
				indexData: [],
				curReCommand: {},
				naviData: [{
					TId: 0,
					title: '首页'
				}]
			}
		},
		mounted() {
			//所有分类
			this.getAllType()
			//推荐视频
			this.getTJVideoList()
			//首页数据
			this.getVlogVideoIndex()
		},
		created() {
			this.screenWidth = document.body.clientWidth
			window.onresize = () => {
				return (() => {
					this.screenWidth = document.body.clientWidth
				})()
			}
		},
		watch: {
			screenWidth: {
				handler: function(val, oldVal) {
					if (val < 1280) {
						this.columnsNum = 4
					} else if (val < 1600) {
						this.columnsNum = 5
					} else if (val <= 1900) {
						this.columnsNum = 6
					} else {
						this.columnsNum = 7
					}
				},
			},
		},
		methods: {
			//视频分类
			getAllType() {
				this.$api.post('/VideoNew/getAllType').then(res => {
					if (res.code == 200) {
						res.data.forEach(item => {
							this.naviData.push(item)
						})
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//推荐视频列表
			getTJVideoList() {
				this.$api.post('/VideoNew/getVlogVideoList', {
					IsRecommend: 1,
				}).then(res => {
					if (res.code == 200) {
						this.listData = res.data.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//推荐视频列表
			getVlogVideoList(tid, index) {
				this.$api.post('/VideoNew/getVlogVideoList', {
					TId: tid,
					IsRecommend: 0,
				}).then(res => {
					if (res.code == 200) {
						this.indexData[index].list[0].list = res.data.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//首页数据
			getVlogVideoIndex() {
				this.isLoading = true
				this.$api.post('/VideoNew/getVlogVideoIndex', {}).then(res => {
					if (res.code == 200) {
						this.indexData = res.data
						this.indexData.forEach(() => {
							this.secSelIndexs.push(0)
						})
						this.isLoading = false
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//改变二级分类菜单
			changeIndex(index, gIndex) {
				this.$set(this.secSelIndexs, index, gIndex);
			},
			//左侧菜单
			naviToLeftBar(item, index) {
				this.tid = item.TId
				this.indexData = []
				this.secSelIndexs = []
				this.leftSelIndex = index
				if (item.TId == 0) {
					this.getVlogVideoIndex()
				} else {
					item.list.forEach(lItem => {
						let indexItem = lItem
						this.$set(indexItem, 'list', [])
						indexItem.list.push({
							TId: lItem.TId,
							title: lItem.title,
							parent_id: lItem.parent_id,
							list: []
						})
						this.indexData.push(indexItem)
					})
					this.indexData.forEach(() => {
						this.secSelIndexs.push(0)
					})
					this.indexData.forEach((listItem, lIndex) => {
						this.getVlogVideoList(listItem.list[0].TId, lIndex)
					})
				}
			},
			hotBigMouseEnter(e, index, item) {
				this.isBig = true
				this.curReCommand = item
				this.isPop = true
				this.popX = e.target.offsetLeft
				this.popY = e.target.offsetTop - (512 - e.target.offsetHeight) / 2
			},
			hotMouseEnter(e, index, item) {
				this.isBig = false
				this.curReCommand = item
				this.isPop = true
				if (index % this.columnsNum == 0) {
					this.popX = e.target.offsetLeft
				} else if (index % this.columnsNum == this.columnsNum - 1) {
					this.popX = e.target.offsetLeft - (394 - e.target.offsetWidth)
				} else {
					this.popX = e.target.offsetLeft - (394 - e.target.offsetWidth) / 2
				}
				this.popY = e.target.offsetTop - (440 - e.target.offsetHeight - 50) / 2
			},
			changeIsPop(isShow) {
				this.isPop = isShow
			},
			naviToDetails(videoId) {
				let routeData = this.$router.resolve({
					path: '/Details',
					query: {
						videoId: videoId
					}
				});
				window.open(routeData.href, '_blank');
			},
			naviToMore(title, tid) {
				let routeData = this.$router.resolve({
					path: '/More',
					query: {
						title: title,
						tid: tid
					}
				});
				window.open(routeData.href, '_blank');
			}
		}
	}
</script>

<style lang="scss" scoped>
	.home {
		display: flex;
		flex-direction: column;
		position: relative;
	}

	.loading {
		position: absolute;
		left: calc(50% - 22px);
		top: 70px;

		img {
			width: 44px;
			height: 44px;
		}
	}

	.leftBar {
		position: fixed;
		left: 0;
		top: 0;
		height: 100vh;
		width: 120px;
		z-index: 1010;
		margin-top: 70px;
		min-height: 600px;
		direction: rtl;

		.navList {
			position: relative;
			height: calc(100% - 72px);

			.navListBox {
				width: 100px;
				text-align: left;
				padding-bottom: 46px;

				.navItem {
					display: block;
					color: hsla(0, 0%, 100%, .5);
					height: 46px;
					line-height: 46px;
					font-size: 16px;
					position: relative;
					overflow: hidden;
					font-weight: 400;
					-webkit-font-smoothing: antialiased;
					cursor: pointer;
				}

				.naviCurItem {
					color: #fff;
					font-size: 20px;
					font-weight: 600;
				}

				.navItem:hover {
					color: #fff;
					font-size: 20px;
					font-weight: 600;
				}
			}
		}
	}

	.videoBox {
		margin-top: 70px;
		margin-left: 158px;
		margin-right: 46px;
	}

	.contentStyle {
		color: rgba(255, 255, 255, 0.87);

		.styleHeader {
			display: flex;
			align-items: baseline;
			justify-content: space-between;

			.headerBox {
				display: flex;
				align-items: center;
				margin: 0px 0px 10px;
				height: 50px;
				line-height: 50px;

				.headerTitle {
					margin-right: 16px;
					font-weight: 500;
					text-align: left;
					font-size: 24px;
					cursor: auto;
				}

				.secordBox {
					display: flex;
					overflow-x: auto;
					max-width: calc(100vw - 270px);

					&::-webkit-scrollbar {
						width: 0px;
						height: 0px;
					}

					.secordItem {
						white-space: nowrap;
						padding: 0px 24px 0px 0px;
						border-radius: 14px;
						height: 28px;
						line-height: 28px;
						color: hsla(0, 0%, 100%, .5);
						font-weight: 400;
						text-align: center;
						cursor: pointer;
					}

					.secordItemNormal {
						font-size: 18px;
						color: hsla(0, 0%, 100%, .5);
						font-weight: 400;
					}

					.secordItemActive {
						font-size: 24px;
						color: #eaeaea;
						font-weight: 500;
					}

					.secordItem:hover {
						font-weight: 500;
						color: #4ae3fa;
					}
				}
			}

			.more {
				display: flex;
				align-items: center;
				font-size: 16px;
				cursor: pointer;

				.moreIcon {
					font-size: 26px;
				}
			}
		}

		.videoListBox {
			display: flex;

			.itemBox {
				padding-right: 12px;
				box-sizing: border-box;
				margin-bottom: 18px;

				.imgBox {
					border-radius: 10px;
					background: #25252b;
					position: relative;
					overflow: hidden;
					cursor: pointer;

					img {
						width: 100%;
						height: 100%;
						object-fit: cover;
						transition: transform 0.3s;
					}

					img:hover {
						transform: scale(1.1);
					}

					.timeNumBox {
						display: flex;
						align-items: center;
						justify-content: space-between;
						width: 100%;
						height: 26px;
						line-height: 26px;
						background: rgba(4, 4, 4, .29);
						position: absolute;
						bottom: 0px;
						left: 0px;
						text-align: right;
						padding: 0px 12px;
						box-sizing: border-box;
						font-size: 12px;
						font-weight: 400;
						color: #FAF7F7;
					}
				}

				.infoBox {
					padding-top: 10px;

					.videoTitle {
						height: 22px;
						width: 100%;
						line-height: 22px;
						font-size: 16px;
						font-weight: 500;
						color: #B4B4B4;
						overflow: hidden;
						text-overflow: ellipsis;
						word-break: break-all;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
						word-break: break-word;
						cursor: pointer;
					}

					.videoTitle:hover {
						color: #4ae3fa;
					}

					.videoSubTitle {
						// color: rgba(255, 255, 255, 0.5);
						color: #767678;
						margin-top: 3px;
						height: 14px;
						line-height: 14px;
						font-size: 14px;
						font-weight: 400;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
				}
			}
		}

		.videoListTBox {
			display: flex;

			.itemTBox {
				padding-right: 12px;
				box-sizing: border-box;

				.imgTBox {
					border-radius: 10px 10px 0px 0px;
					background: #25252b;
					position: relative;
					overflow: hidden;
					cursor: pointer;

					img {
						width: 100%;
						height: 100%;
						object-fit: cover;
					}

					.timeBox {
						width: 100%;
						height: 40px;
						line-height: 40px;
						background: rgba(4, 4, 4, .29);
						position: absolute;
						bottom: 0px;
						left: 0px;
						text-align: right;
						padding-right: 12px;
						box-sizing: border-box;
						font-size: 12px;
						font-weight: 400;
						color: #FAF7F7;
					}
				}

				.infoTBox {
					background-color: #25252b;
					padding: 18px;
					max-height: 80px;
					min-height: 80px;

					.videoTitle {
						height: 22px;
						width: 100%;
						line-height: 22px;
						font-size: 16px;
						font-weight: 500;
						color: #B4B4B4;
						overflow: hidden;
						text-overflow: ellipsis;
						word-break: break-all;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
						word-break: break-word;
						cursor: pointer;
					}

					.videoTitle:hover {
						color: #4ae3fa;
					}

					.videoSubTitle {
						// color: rgba(255, 255, 255, 0.5);
						color: #767678;
						margin-top: 12px;
						height: 14px;
						line-height: 14px;
						font-size: 14px;
						font-weight: 400;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}

					.videoDescTitle {
						display: flex;
						align-items: center;
						justify-content: space-between;
						color: hsla(0, 0%, 100%, .5);
						margin-top: 12px;
						height: 17px;
						line-height: 17px;
						font-size: 14px;
						font-weight: 400;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;

						.playNum {
							font-size: 16px;
							font-weight: 400;
							color: #767678;
						}
					}
				}
			}
		}

		.videoListSBox {
			display: flex;

			.itemSBox {
				padding-right: 12px;
				box-sizing: border-box;
				margin-bottom: 60px;

				.imgSBox {
					border-radius: 10px 10px 0px 0px;
					background: #25252b;
					position: relative;
					overflow: hidden;
					cursor: pointer;

					img {
						width: 100%;
						height: 100%;
						object-fit: cover;
					}

					.timeNumBox {
						display: flex;
						align-items: center;
						justify-content: space-between;
						width: 100%;
						height: 26px;
						line-height: 26px;
						background: rgba(4, 4, 4, .29);
						position: absolute;
						bottom: 0px;
						left: 0px;
						text-align: right;
						padding: 0px 12px;
						box-sizing: border-box;
						font-size: 12px;
						font-weight: 400;
						color: #FAF7F7;
					}
				}

				.infoSBox {
					padding-top: 10px;

					.videoTitle {
						height: 22px;
						width: 100%;
						line-height: 22px;
						font-size: 16px;
						font-weight: 500;
						color: #B4B4B4;
						overflow: hidden;
						text-overflow: ellipsis;
						word-break: break-all;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
						word-break: break-word;
						cursor: pointer;
					}

					.videoTitle:hover {
						color: #4ae3fa;
					}

					.videoSubTitle {
						// color: rgba(255, 255, 255, 0.5);
						color: #767678;
						margin-top: 3px;
						height: 14px;
						line-height: 14px;
						font-size: 14px;
						font-weight: 400;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
				}
			}
		}

		.adBox {
			height: 100px;
			// width: calc(100vw - 204px);
			margin-bottom: 40px;
			border-radius: 4px;
			overflow: hidden;
			position: relative;
			cursor: pointer;

			img {
				width: 100%;
				height: 100%;
			}

			.adTipBox {
				position: absolute;
				height: 18px;
				right: 8px;
				top: 0px;
				font-size: 12px;
				line-height: 18px;
				text-align: center;
				padding: 0px 4px;
				background: rgba(0, 0, 0, .6);
			}
		}
	}

	@media (max-width: 1099px) {
		.contentStyle .videoListBox .itemBox {
			width: calc((1100px - 204px) / 4);

			.imgBox {
				height: calc((1100px - 204px) / 4 / 1.794);
			}
		}

		.contentStyle .videoListTBox .itemTBox {
			width: calc((1100px - 204px) / 4 * 2);

			.imgTBox {
				height: calc((1100px - 204px) / 4 * 2 / 1.794);
			}
		}

		.contentStyle .videoListSBox .itemSBox {
			width: calc((1100px - 204px) / 4);

			.imgSBox {
				height: calc((1100px - 204px) / 4 * 1.333);
			}
		}
	}

	@media (min-width: 1100px) and (max-width:1279px) {
		.contentStyle .videoListBox .itemBox {
			width: calc((100vw - 204px) / 4);

			.imgBox {
				height: calc((100vw - 204px) / 4 / 1.794);
			}
		}

		.contentStyle .videoListTBox .itemTBox {
			width: calc((100vw - 204px) / 4 * 2);

			.imgTBox {
				height: calc((100vw - 204px) / 4 * 2 / 1.794);
			}
		}

		.contentStyle .videoListSBox .itemSBox {
			width: calc((100vw - 204px) / 4);

			.imgSBox {
				height: calc((100vw - 204px) / 4 * 1.333);
			}
		}
	}

	@media (min-width: 1280px) and (max-width:1599px) {
		.contentStyle .videoListBox .itemBox {
			width: calc((100vw - 204px) / 5);

			.imgBox {
				height: calc((100vw - 204px) / 5 / 1.794);
			}
		}

		.contentStyle .videoListTBox .itemTBox {
			width: calc((100vw - 204px) / 5 * 2);

			.imgTBox {
				height: calc((100vw - 204px) / 5 * 2 / 1.794);
			}
		}

		.contentStyle .videoListSBox .itemSBox {
			width: calc((100vw - 204px) / 5);

			.imgSBox {
				height: calc((100vw - 204px) / 5 * 1.333);
			}
		}
	}

	@media (min-width: 1600px) and (max-width:1899px) {
		.contentStyle .videoListBox .itemBox {
			width: calc((100vw - 204px) / 6);

			.imgBox {
				height: calc((100vw - 204px) / 6 / 1.794);
			}
		}

		.contentStyle .videoListTBox .itemTBox {
			width: calc((100vw - 204px) / 6 * 2);

			.imgTBox {
				height: calc((100vw - 204px) / 6 * 2 / 1.794);
			}
		}

		.contentStyle .videoListSBox .itemSBox {
			width: calc((100vw - 204px) / 6);

			.imgSBox {
				height: calc((100vw - 204px) / 6 * 1.333);
			}
		}
	}

	@media (min-width: 1900px) {
		.contentStyle .videoListBox .itemBox {
			width: calc((100vw - 204px) / 7);

			.imgBox {
				height: calc((100vw - 204px) / 7 / 1.794);
			}
		}

		.contentStyle .videoListTBox .itemTBox {
			width: calc((100vw - 204px) / 7 * 2);

			.imgTBox {
				height: calc((100vw - 204px) / 7 * 2 / 1.794);
			}
		}

		.contentStyle .videoListSBox .itemSBox {
			width: calc((100vw - 204px) / 7);

			.imgSBox {
				height: calc((100vw - 204px) / 7 * 1.333);
			}
		}
	}
</style>